import React from "react";

interface ClientAvatarProps {
  size?: number;
  className?: string;
}

export default function ClientAvatar({ size = 32, className }: ClientAvatarProps) {
  const iconSize = Math.round(size / 2);
  return (
    <div
      className={`rounded-full flex items-center justify-center flex-shrink-0 ${className || ""}`}
      style={{ width: size, height: size, background: "#DBEAFE" }}
    >
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
        <path
          d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
          fill="#3B82F6"
        />
      </svg>
    </div>
  );
}
